import getConfig from 'next/config'

import { GoogleMapsSettings, MarkerClusters, Pin } from '@grandvisionhq/common'
import { Components } from '@grandvisionhq/stores-v2'

const { publicRuntimeConfig } = getConfig()
const gmKey = publicRuntimeConfig.googleMaps.apiKey ?? ''
const gmCenter = publicRuntimeConfig.googleMaps.mapCenter ?? {}

const { PreferredStorePin } = Components

const pinThemes = {
  primary: { foreground: '#ffffff', background: '#526A6B' },
  highlight: { foreground: '#ffffff', background: '#1D2B2C' },
  hovered: { foreground: '#465D5E', background: '#ffffff' },
}

export const getGoogleMapsConfig = (): GoogleMapsSettings => ({
  apiKey: gmKey,
  defaultCenter: gmCenter,
  defaultZoom: 6,
  pin: Pin({
    themes: pinThemes,
  }),
  preferredStorePin: PreferredStorePin({
    themes: pinThemes,
  }),
  markerClusterOptions: MarkerClusters({
    theme: {
      color: '#C8D400',
      textColor: '#ffffff',
    },
    minimumClusterSize: 3,
    maxZoom: 10,
  }),
})
